export default __webpack_public_path__ + "static/media/LoginA.cca7a3ed.jpg";